import { IObjectTranslatable } from ".";
import { ITypeDefinable } from "../beans/items";
import { TypeKeys, IItem, InvisibleItem } from "../../../../domain/document/items";


export class HeaderFooterTextItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const result = new InvisibleItem(TypeKeys.HeaderFooterTextItem, item);
    result.privateId = (item as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = item.uniqueKey;
    result.id = item.id;
    result.sectionObjectUid = item.sectionObjectUid;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    // 何も返さないとオブジェクト自体が無かったことになってしまうので、とりあえず元のbeanを返却する
    const target = item as InvisibleItem;
    return target.source !== undefined
      ? target.source
      : null;
  }
}
